import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=23469698&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"
import style0 from "./Campaigns.vue?vue&type=style&index=0&id=23469698&prod&lang=scss"
import style1 from "./Campaigns.vue?vue&type=style&index=1&id=23469698&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23469698",
  null
  
)

export default component.exports